import { t } from "@lingui/macro";

import { BookingWizard } from "../../types";

export const useGetLayoutHoleCountString = () => {
  return (code: string, holeCount: BookingWizard.HoleCount): string => {
    if (code === "9BACK" || code === "9FRONT") {
      return t`9 Holes`;
    }
    if (holeCount === "EIGHTEEN") {
      return t`18 Holes`;
    }
    if (holeCount === "NINE") {
      return t`9 Holes`;
    }
    return "";
  };
};
